import { render, staticRenderFns } from "./franchiseList.vue?vue&type=template&id=38706051&scoped=true"
import script from "./franchiseList.vue?vue&type=script&lang=js"
export * from "./franchiseList.vue?vue&type=script&lang=js"
import style0 from "./franchiseList.vue?vue&type=style&index=0&id=38706051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38706051",
  null
  
)

export default component.exports